export const LOW_CONTRAST_MESSAGE =
  "This ink color may not have enough contrast against the product color you've chosen.";
export const MOBILE_LOW_CONTRAST_MESSAGE =
  "The selected ink color might not have enough contrast against the product color you've chosen.";
export const COLOR_SWATCH_HOVER_WARNING =
  "This ink color doesn’t have enough contrast against the product color you've chosen and may not print well.";
